import { Component, Input } from "@angular/core";
import { CoreIconButton, CoreSidebar, CoreSvsLogo } from "@svs/angular";

@Component({
  selector: "app-sidebar-header",
  imports: [
    CoreIconButton,
    CoreSvsLogo,
  ],
  templateUrl: "./sidebar-header.component.html",
  styleUrl: "./sidebar-header.component.scss",
})
export class SidebarHeaderComponent {
  @Input() sidebar: CoreSidebar;
}
